import { create } from "zustand";
import { fetchLLmProviders } from "./llmProvidersApi";
import { notifications } from "@mantine/notifications";
import i18n from "../i18n";

export const useLlmProvidersStore = create((set, get) => ({
  llmProviders: null,
  isLoading: true,

  fetchLlmProviders: async () => {
    set({ isLoading: true });
    try {
      const llmProviders = await fetchLLmProviders();
      set({
        llmProviders,
        isLoading: false,
      });
    } catch (err) {
      notifications.show({
        title: i18n.t(
          "llmproviders.notifications.fetch_failed",
          "Failed to fetch LLM Providers"
        ),
        color: "red",
      });
      set({ isLoading: false });
    }
  },

  getLlmProviderById: async (llmProviderId) => {
    const existingLlmProvider = get().llmProviders?.find(
      (b) => b.id === llmProviderId
    );
    if (existingLlmProvider) {
      // console.log("LLM Provider found in store:", existingLlmProvider);
      return existingLlmProvider;
    }
    console.log("LLM Provider not found in store, fetching:", llmProviderId);
    return null; // Return null if not found in store

    // If LLM Provider is not in the store, fetch it:
    // set({ isLoading: true });
    // try {
    //   const llmProvider = await fetchLLmProviderById(llmProviderId);
    //   set({
    //     llmProviders: [...get().llmProviders, llmProvider],
    //     isLoading: false,
    //   });
    // } catch (err) {
    //   notifications.show({
    //     title: i18n.t(
    //       "llmproviders.notifications.fetch_failed",
    //       "Failed to fetch LLM Provider"
    //     ),
    //     color: "red",
    //   });
    // }
  },
}));
